import { ready } from "../utils";

const removeBlocklistedParams = () => {
  const
    urlParams = new URLSearchParams(location.search),
    affiliateCodeParam = currentUser.affiliate_code;
    let blocklistedParams = [
      'jwt',
      'eu',
      'ali',
      'unlock',
      'pu',
      'freelink_shortcode',
      'fb_news_token',
      'cio_link_id',
      'rc' // Remove incoming rc if any; add this user's rc below
    ];
  blocklistedParams.forEach(param => urlParams.delete(param));
  if (urlParams.toString() === "") {
    window.history.replaceState({}, document.title, `${location.pathname}${location.hash}`);
  } else {
    window.history.replaceState({}, document.title, `${location.pathname}?${urlParams}${location.hash}`);
  }
  // Add this user's rc to the URL, in case they share the page
  if (affiliateCodeParam && history.pushState) {
    urlParams.set('rc', affiliateCodeParam);
    const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({}, document.title, newUrl)
  }
}

ready(removeBlocklistedParams);
